
import React from "react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/lib/brand/ThemeProvider";
import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";

interface ThemeToggleProps {
  variant?: "default" | "outline" | "icon";
  className?: string;
}

export function ThemeToggle({ variant = "default", className }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  // Icon-only toggle
  if (variant === "icon") {
    return (
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleTheme}
        className={cn("rounded-xl", className)}
      >
        {theme === "light" ? (
          <Moon className="h-[1.2rem] w-[1.2rem] rotate-90 transition-all dark:rotate-0" />
        ) : (
          <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 transition-all dark:-rotate-90" />
        )}
        <span className="sr-only">Toggle theme</span>
      </Button>
    );
  }

  // Default button toggle
  return (
    <Button
      variant={variant === "outline" ? "outline" : "default"}
      size="sm"
      onClick={toggleTheme}
      className={cn("gap-2", className)}
    >
      {theme === "light" ? (
        <>
          <Moon className="h-[1rem] w-[1rem]" />
          <span>Dark</span>
        </>
      ) : (
        <>
          <Sun className="h-[1rem] w-[1rem]" />
          <span>Light</span>
        </>
      )}
    </Button>
  );
}
